/**
 * @module app.core
 */

import { DynamicViews } from 'app/shared/config/modules';
import { PLATFORM } from 'aurelia-pal';

export function getCoreQuestionTypes(): DynamicViews {
    return {
        'TextBox':
            [{ title: 'Single-Line Text', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-textbox') }],
        'DropDownList':
            [{ title: 'Drop-Down List', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-select') }],
        'CheckBox':
            [{ title: 'Check List (Multi-Select)', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-checkbox') }],
        'RadioButton':
            [{ title: 'Check List (Single Select)', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-radio') }],
        'DatePicker':
            [{ title: 'Date (Month/Day/Year)', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-date') }],
        'MultiLineText':
            [{ title: 'Multi-Line Text', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-textarea') }],
        'MonthYear':
            [{ title: 'Date (Month/Year)', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-month-year') }],
        'NumericTextBox':
            [{ title: 'Number (Integer)', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-number') }],
        'DateTime':
            [{ title: 'Date/Time', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-datetime') }],
        'DecimalTextBox':
            [{ title: 'Number (Decimal)', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-decimal') }],
        'Task':
            [{ title: 'Suggest Task', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-suggest-task') }],
        'DateTimeSecond':
            [{ title: 'Date/Time (Seconds)', url: PLATFORM.moduleName('app/core/components/assessments/questions/question-datetimesecond') }]
    };
}
